/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import {  useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const Table = ({
    pageNumber, 
    getListData, 
    setToastErrorMessage, searchParams,
    setConfirmationState, handleSidePopupClick,email,setLoading,totalCount}) => {
    const dispactch=useDispatch()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const Payroll = useSelector(state => state.payrollSlice);
    const { List } = Payroll
    
    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    
    return (<>
        
        <div className='text-center absolute w-full'>Uploaded Payrolls for <span className="font-semibold">{searchParams?.get('financial_year')}</span></div>
        <div className={`flex mb-3 overflow-auto ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1 topHeading`} id = "search-result" >
            <table aria-label="Outside Table" className="w-full" id='admin-table'>
                <thead>
                    <tr>
                        <th class="w-[10%]">
                            <span class="justify-start">Month
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span class="flex items-end justify-end"># of Employees
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span >Uploaded on
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span class="flex items-center justify-Start">Uploaded By
                            </span>
                        </th>
                        <th class="w-[12%]">
                            <span class="flex items-center justify-center">Document
                            </span>
                        </th>
                        <th class="w-[18%]">
                            <span class="flex items-start justify-start">Notes
                            </span>
                        </th>
                        <th class="w-[12%]">
                            <span class="flex items-center justify-center">Action
                            </span>
                        </th>
                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                            
                </thead>
                <tbody>
                    {List?.data?.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                setConfirmationState={setConfirmationState}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.data?.length}
                                email={email}
                                searchParams={searchParams}
                                handleSidePopupClick={handleSidePopupClick}
                                getListData={getListData}
                                setLoading={setLoading}
                                setToastErrorMessage={setToastErrorMessage}
                            />
                        </Fragment>
                    ))}
                        
                </tbody>
                {(List?.data?.length === 0) && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                {`No payrolls uploaded for the FY`}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>

    </>
    );
}

export default Table;
